import React from "react";
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import MenuItem from "@material-ui/core/MenuItem";
import MenuList from "@material-ui/core/MenuList";
import Grow from "@material-ui/core/Grow";
import Paper from "@material-ui/core/Paper";
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import Hidden from "@material-ui/core/Hidden";
import Poppers from "@material-ui/core/Popper";
import Divider from "@material-ui/core/Divider";
// @material-ui/icons
import Person from "@material-ui/icons/Person";
import Notifications from "@material-ui/icons/Notifications";
import Dashboard from "@material-ui/icons/Dashboard";
import Search from "@material-ui/icons/Search";
// core components
import CustomInput from "admin/components/CustomInput/CustomInput.js";
import Button from "admin/components/CustomButtons/Button.js";

import styles from "assets/jss/material-dashboard-react/components/headerLinksStyle.js";
import axios from "axios";
import { baseUrl } from "Environment";
import { requestConfigAdmin } from "Environment";
import { refreshHeaderAdmin } from "Environment";
import Confirmation from "../CustomDialogs/Confirmation";
import {
  prefix
} from '../../../Environment.js';

const useStyles = makeStyles(styles);

export default function AdminNavbarLinks(props) {
  const classes = useStyles();
  const [openProfile, setOpenProfile] = React.useState(null);
  const [openDialog, setOpenDialog] = React.useState(false);


  const handleClickProfile = event => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };

  const handleLogoutClick = () => {
    setOpenDialog(true)
  }

  const handleLogout = (res) => {
    if (res) {
      axios.get(`${baseUrl}/logout`, requestConfigAdmin).then((res) => {
        if (res.data.success) {
          localStorage.removeItem('auth_admin');
          refreshHeaderAdmin();
          let path = prefix + `/admin/login`;
          props.history.push(path);
        } else {
          console.log(res.data.message, res.data.data)
        }
      }, (e) => {
        console.log("Error : ", e);
      })
    } else {
      setOpenDialog(false)
    }
  }

  return (
    <div>
      <div className={classes.manager}>
        <Confirmation
          openDialog={openDialog}
          message={`You are about to <b>Logout</b>, 
            are you sure you want to Logout?`}
          handleCloseDialog={handleLogout}
        />
        <Button
          color={window.innerWidth > 959 ? "transparent" : "white"}
          justIcon={window.innerWidth > 959}
          simple={!(window.innerWidth > 959)}
          aria-owns={openProfile ? "profile-menu-list-grow" : null}
          aria-haspopup="true"
          onClick={handleClickProfile}
          className={classes.buttonLink}
        >
          <Person className={classes.icons} />
          <Hidden mdUp implementation="css">
            <p className={classes.linkText}>Profile</p>
          </Hidden>
        </Button>
        <Poppers
          open={Boolean(openProfile)}
          anchorEl={openProfile}
          transition
          disablePortal
          className={
            classNames({ [classes.popperClose]: !openProfile }) +
            " " +
            classes.popperNav
          }
        >
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              id="profile-menu-list-grow"
              style={{
                transformOrigin:
                  placement === "bottom" ? "center top" : "center bottom"
              }}
            >
              <Paper>
                <ClickAwayListener onClickAway={handleCloseProfile}>
                  <MenuList role="menu">
                    <MenuItem
                      onClick={() => { handleCloseProfile(); props.history.push(prefix + '/admin/profile') }}
                      className={classes.dropdownItem}
                    >
                      Profile
                    </MenuItem>
                    <Divider light />
                    <MenuItem
                      onClick={() => { handleCloseProfile(); handleLogoutClick(); }}
                      className={classes.dropdownItem}
                    >
                      Logout
                    </MenuItem>
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Poppers>
      </div>
    </div>
  );
}
